import { render, staticRenderFns } from "./EditableName.vue?vue&type=template&id=63a98ebe&scoped=true&"
import script from "./EditableName.vue?vue&type=script&lang=js&"
export * from "./EditableName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a98ebe",
  null
  
)

export default component.exports